import { Component } from '../core/Component';

/**
 * Axis-aligned bounding box for collision detection.
 */
export class Collider extends Component {
  /** Width of the collision box */
  width: number = 0;
  /** Height of the collision box */
  height: number = 0;
  /** Horizontal offset from entity position */
  offsetX: number = 0;
  /** Vertical offset from entity position */
  offsetY: number = 0;
  /** Collision layer (for filtering) */
  layer: number = 0;
  /** Layers this collider can collide with (bitmask) */
  mask: number = 0xffffffff;
  /** Whether this collider is a trigger (no physical response) */
  isTrigger: boolean = false;
}
